/**
 * Quiz Email Handler API - 独立的邮箱收集和结果发送系统
 * 版本: 1.0.0
 * 兼容性: Playtime主题 (Ignite 2.1.2)
 * 
 * 确保与主题完全兼容，不会影响现有功能
 */

(function() {
  'use strict';
  
  // 避免重复加载
  if (window.QuizEmailHandler) {
    console.warn('QuizEmailHandler already loaded');
    return;
  }

  // 命名空间前缀，避免与主题冲突
  const QUIZ_PREFIX = 'quiz-email-';
  const QUIZ_EVENTS = {
    emailSubmitted: 'quiz-email-submitted',
    resultShown: 'quiz-result-shown',
    modalOpened: 'quiz-modal-opened',
    modalClosed: 'quiz-modal-closed'
  };

  /**
   * 主要的Quiz Email Handler类
   */
  class QuizEmailHandler {
    constructor() {
      this.currentQuizData = null;
      this.isSubmitting = false;
      this.modalElement = null;
      this.overlayElement = null;
      
      // 绑定方法上下文
      this.handleModalClose = this.handleModalClose.bind(this);
      this.handleEscapeKey = this.handleEscapeKey.bind(this);
      this.handleEmailSubmit = this.handleEmailSubmit.bind(this);
      
      // 初始化
      this.init();
    }

    /**
     * 初始化函数
     */
    init() {
      // 确保DOM加载完成
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.createStylesheet());
      } else {
        this.createStylesheet();
      }
    }

    /**
     * 创建必要的CSS样式，复用主题现有样式
     */
    createStylesheet() {
      if (document.getElementById(QUIZ_PREFIX + 'styles')) return;

      const style = document.createElement('style');
      style.id = QUIZ_PREFIX + 'styles';
      style.textContent = `
        /* Quiz Email Handler样式 - 复用主题样式，避免冲突 */
        .quiz-email-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.6);
          z-index: 9999;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          opacity: 0;
          visibility: hidden;
          transition: opacity 0.3s ease, visibility 0.3s ease;
        }

        .quiz-email-overlay.active {
          opacity: 1;
          visibility: visible;
        }

        .quiz-email-modal {
          background: rgb(var(--color-background));
          border-radius: var(--media-radius, 20px);
          max-width: 500px;
          width: 100%;
          max-height: 90vh;
          overflow-y: auto;
          transform: translateY(20px);
          transition: transform 0.3s ease;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
        }

        .quiz-email-overlay.active .quiz-email-modal {
          transform: translateY(0);
        }

        .quiz-email-header {
          padding: 30px 30px 0;
          text-align: center;
          position: relative;
        }

        .quiz-email-close {
          position: absolute;
          top: 15px;
          right: 15px;
          background: none;
          border: none;
          font-size: 24px;
          cursor: pointer;
          color: rgb(var(--color-foreground));
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          transition: background 0.2s ease;
        }

        .quiz-email-close:hover {
          background: rgba(var(--color-foreground), 0.1);
        }

        .quiz-email-title {
          font-family: var(--font-heading-family);
          font-size: var(--font-heading-h3-size, 2rem);
          font-weight: var(--font-heading-weight);
          color: rgb(var(--color-heading));
          margin: 0 0 10px;
          line-height: 1.2;
        }

        .quiz-email-description {
          color: rgb(var(--color-foreground));
          margin: 0 0 20px;
          font-size: var(--font-body-size);
        }

        .quiz-email-content {
          padding: 20px 30px 30px;
        }

        .quiz-email-form {
          margin-bottom: 20px;
        }

        .quiz-email-field {
          position: relative;
          margin-bottom: 20px;
        }

        .quiz-email-input {
          width: 100%;
          padding: 15px 50px 15px 20px;
          border: 2px solid rgba(var(--color-foreground), 0.2);
          border-radius: var(--inputs-radius, 6px);
          font-size: var(--font-body-size);
          color: rgb(var(--color-foreground));
          background: rgb(var(--color-background));
          transition: border-color 0.2s ease;
        }

        .quiz-email-input:focus {
          outline: none;
          border-color: rgb(var(--color-button));
        }

        .quiz-email-input.error {
          border-color: #dc3545;
        }

        .quiz-email-icon {
          position: absolute;
          right: 15px;
          top: 50%;
          transform: translateY(-50%);
          color: rgba(var(--color-foreground), 0.5);
        }

        .quiz-email-error {
          color: #dc3545;
          font-size: 0.875rem;
          margin-top: 5px;
          display: none;
        }

        .quiz-email-error.show {
          display: block;
        }

        .quiz-email-submit {
          width: 100%;
          padding: 12px 24px;
          font-size: 18px;
          color: #fff;
          background-color: rgba(155,145,234,1);
          border: none;
          border-radius: 30px;
          cursor: pointer;
          transition: all 0.2s ease;
          position: relative;
          font-weight: normal;
        }

        .quiz-email-submit:hover {
          background-color: rgba(125,115,204,1);
          transform: translateY(-1px);
        }

        .quiz-email-submit:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }

        .quiz-email-loading {
          display: none;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }

        .quiz-email-submit.loading .quiz-email-loading {
          display: block;
        }

        .quiz-email-submit.loading .quiz-email-text {
          opacity: 0;
        }

        .quiz-email-spinner {
          width: 20px;
          height: 20px;
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-radius: 50%;
          border-top: 2px solid white;
          animation: quiz-spin 1s linear infinite;
        }

        @keyframes quiz-spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        .quiz-result-preview {
          padding: 20px;
          background: rgba(var(--color-foreground), 0.05);
          border-radius: var(--media-radius, 20px);
          margin-bottom: 20px;
          text-align: center;
        }

        .quiz-result-image {
          width: 120px;
          height: 120px;
          border-radius: 50%;
          margin: 0 auto 15px;
          overflow: hidden;
          background: rgba(var(--color-foreground), 0.1);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .quiz-result-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .quiz-result-text {
          font-family: var(--font-heading-family);
          font-size: 1.25rem;
          font-weight: var(--font-heading-weight);
          color: rgb(var(--color-heading));
          margin: 0;
        }

        .quiz-success-state {
          display: none;
          text-align: center;
          padding: 20px;
        }

        .quiz-success-state.show {
          display: block;
        }

        .quiz-success-icon {
          width: 60px;
          height: 60px;
          background: #28a745;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 20px;
          color: white;
          font-size: 24px;
        }

        .quiz-success-title {
          font-family: var(--font-heading-family);
          font-size: 1.5rem;
          color: rgb(var(--color-heading));
          margin: 0 0 10px;
        }

        .quiz-success-description {
          color: rgb(var(--color-foreground));
          margin: 0 0 20px;
        }

        /* 移动端适配 */
        @media (max-width: 749px) {
          .quiz-email-modal {
            margin: 20px;
            max-width: calc(100vw - 40px);
          }

          .quiz-email-header {
            padding: 20px 20px 0;
          }

          .quiz-email-content {
            padding: 15px 20px 20px;
          }

          .quiz-email-title {
            font-size: 1.5rem;
          }
        }
      `;
      
      document.head.appendChild(style);
    }

    /**
     * 主要API方法：提交quiz结果并收集邮箱
     * @param {Object} options - 配置选项
     */
    submitQuizResult(options = {}) {
      // 验证必要参数
      if (!options.quizResult) {
        console.error('QuizEmailHandler: quizResult is required');
        return;
      }

      // 默认配置
      const config = {
        quizTitle: 'Quiz Result',
        resultText: 'Your quiz result is ready!',
        resultImage: null,
        emailPlaceholder: 'Enter your email address...',
        submitButtonText: 'Get My Result',
        successTitle: 'Check Your Email!',
        successMessage: 'Your quiz result has been sent to your email address.',
        modalTitle: 'Get Your Quiz Result',
        modalDescription: 'Enter your email to receive your personalized quiz result!',
        onEmailSubmitted: null,
        onResultShown: null,
        onModalClosed: null,
        autoShowResult: true,
        showResultPreview: true, // 默认显示结果预览，可以设为false隐藏
        ...options
      };

      this.currentQuizData = config;
      this.showEmailCollectionModal();
    }

    /**
     * 显示邮箱收集弹窗
     */
    showEmailCollectionModal() {
      if (this.modalElement) {
        this.closeModal();
      }

      this.createModalElement();
      document.body.appendChild(this.overlayElement);
      
      // 延迟显示，确保CSS过渡效果
      requestAnimationFrame(() => {
        this.overlayElement.classList.add('active');
      });

      // 添加事件监听
      this.addEventListeners();
      
      // 触发事件
      this.dispatchEvent(QUIZ_EVENTS.modalOpened, {
        quizData: this.currentQuizData
      });
    }

    /**
     * 创建模态窗口元素
     */
    createModalElement() {
      this.overlayElement = document.createElement('div');
      this.overlayElement.className = 'quiz-email-overlay';
      
      const config = this.currentQuizData;
      
      this.overlayElement.innerHTML = `
        <div class="quiz-email-modal">
          <div class="quiz-email-header">
            <button type="button" class="quiz-email-close" aria-label="Close">×</button>
            <h2 class="quiz-email-title">${this.escapeHtml(config.modalTitle)}</h2>
            <p class="quiz-email-description">${this.escapeHtml(config.modalDescription)}</p>
          </div>
          
          <div class="quiz-email-content">
            ${config.showResultPreview && (config.resultText || config.resultImage) ? `
              <div class="quiz-result-preview">
                ${config.resultImage ? `
                  <div class="quiz-result-image">
                    <img src="${config.resultImage}" alt="Quiz Result" />
                  </div>
                ` : ''}
                ${config.resultText ? `
                  <p class="quiz-result-text">${this.escapeHtml(config.resultText)}</p>
                ` : ''}
              </div>
            ` : ''}
            
            <form class="quiz-email-form">
              <div class="quiz-email-field">
                <input 
                  type="email" 
                  class="quiz-email-input" 
                  placeholder="${this.escapeHtml(config.emailPlaceholder)}"
                  required
                  autocomplete="email"
                />
                <div class="quiz-email-icon">✉️</div>
                <div class="quiz-email-error">Please enter a valid email address</div>
              </div>
              
              <button type="submit" class="quiz-email-submit">
                <span class="quiz-email-text">${this.escapeHtml(config.submitButtonText)}</span>
                <div class="quiz-email-loading">
                  <div class="quiz-email-spinner"></div>
                </div>
              </button>
            </form>

            <div class="quiz-success-state">
              <div class="quiz-success-icon">✓</div>
              <h3 class="quiz-success-title">${this.escapeHtml(config.successTitle)}</h3>
              <p class="quiz-success-description">${this.escapeHtml(config.successMessage)}</p>
            </div>
          </div>
        </div>
      `;

      this.modalElement = this.overlayElement.querySelector('.quiz-email-modal');
    }

    /**
     * 添加事件监听器
     */
    addEventListeners() {
      // 关闭按钮
      const closeBtn = this.overlayElement.querySelector('.quiz-email-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', this.handleModalClose);
      }

      // 点击背景关闭
      this.overlayElement.addEventListener('click', (e) => {
        if (e.target === this.overlayElement) {
          this.handleModalClose();
        }
      });

      // ESC键关闭
      document.addEventListener('keydown', this.handleEscapeKey);

      // 表单提交
      const form = this.overlayElement.querySelector('.quiz-email-form');
      if (form) {
        form.addEventListener('submit', this.handleEmailSubmit);
      }
    }

    /**
     * 处理邮箱提交
     */
    async handleEmailSubmit(e) {
      e.preventDefault();
      
      if (this.isSubmitting) return;
      
      const form = e.target;
      const emailInput = form.querySelector('.quiz-email-input');
      const submitBtn = form.querySelector('.quiz-email-submit');
      const errorDiv = form.querySelector('.quiz-email-error');
      
      const email = emailInput.value.trim();
      
      // 验证邮箱
      if (!this.isValidEmail(email)) {
        this.showFieldError(emailInput, errorDiv, 'Please enter a valid email address');
        return;
      }

      // 显示加载状态
      this.isSubmitting = true;
      submitBtn.disabled = true;
      submitBtn.classList.add('loading');
      errorDiv.classList.remove('show');
      emailInput.classList.remove('error');

      try {
        // 提交到Google Sheets系统
        const success = await this.submitToGoogleSheets(email);
        
        if (success) {
          // 显示成功状态
          this.showSuccessState();
          
          // 触发成功回调
          if (this.currentQuizData.onEmailSubmitted) {
            this.currentQuizData.onEmailSubmitted(email, this.currentQuizData);
          }

          // 触发事件
          this.dispatchEvent(QUIZ_EVENTS.emailSubmitted, {
            email: email,
            quizData: this.currentQuizData
          });

          // 如果设置了自动显示结果，3秒后关闭模态窗口
          if (this.currentQuizData.autoShowResult) {
            setTimeout(() => {
              this.closeModal();
              // 不在这里调用showResult，让页面自己的回调处理
            }, 3000);
          }
        } else {
          throw new Error('Submission failed');
        }
      } catch (error) {
        console.error('Quiz email submission failed:', error);
        this.showFieldError(emailInput, errorDiv, 'Sorry, there was an error. Please try again.');
      } finally {
        this.isSubmitting = false;
        submitBtn.disabled = false;
        submitBtn.classList.remove('loading');
      }
    }

    /**
     * 提交邮箱到Google Sheets（主要方法）
     * 使用你的Google Apps Script作为后端
     */
    async submitToGoogleSheets(email) {
      console.log('📊 开始提交邮箱到Google Sheets:', email);
      
      try {
        // 主要方法：使用你的Google Apps Script
        const success1 = await this.submitToGoogleAppsScript(email);
        if (success1) {
          console.log('✅ Google Sheets提交成功');
          return true;
        }
        
        // 备选方法：本地存储 + 可选的其他外部服务
        console.log('💾 使用本地存储作为备份');
        this.saveEmailToLocalStorage(email, {
          quizTitle: this.currentQuizData.quizTitle,
          result: this.currentQuizData.resultText,
          timestamp: new Date().toISOString(),
          source: 'quiz-backup'
        });
        
        return true; // 即使Google Sheets失败，也返回成功以保证用户体验
        
      } catch (error) {
        console.error('❌ Google Sheets提交失败:', error);
        // 保存到本地存储作为备份
        this.saveEmailToLocalStorage(email, {
          quizTitle: this.currentQuizData.quizTitle,
          result: this.currentQuizData.resultText,
          timestamp: new Date().toISOString(),
          source: 'quiz-error-backup',
          error: error.message
        });
        return true; // 仍然返回成功
      }
    }

    /**
     * Google Apps Script提交方法
     * 使用JSONP来避免CORS问题
     */
    async submitToGoogleAppsScript(email) {
      return new Promise((resolve) => {
        try {
          console.log('🌐 开始提交到Google Apps Script');
          
          // 你的Google Apps Script Web App URL
          const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbxLn5EwFndbkek9NCQGhpL1pQtbB6xsmHTxvoQ3qyZ0nozrCkrkW1JfvbDEZY2OKP1B/exec';
          
          // 如果用户没有配置URL，给出提示
          if (GOOGLE_SCRIPT_URL.includes('YOUR_SCRIPT_ID')) {
            console.warn('⚠️ Google Apps Script URL未配置，请设置正确的URL');
            resolve(false);
            return;
          }
          
          // 准备提交数据
          const quizData = {
            email: email,
            quizResult: JSON.stringify({
              character: this.currentQuizData.quizResult?.character || 'unknown',
              characterName: this.currentQuizData.quizResult?.characterName || '',
              quizTitle: this.currentQuizData.quizTitle,
              resultText: this.currentQuizData.resultText,
              timestamp: new Date().toISOString(),
              answers: this.currentQuizData.quizResult?.answers || {},
              detailedAnswers: this.currentQuizData.quizResult?.detailedAnswers || []
            }),
            source: 'plush-quiz-' + (this.currentQuizData.quizTitle || 'unknown').replace(/\s+/g, '-').toLowerCase(),
            userAgent: navigator.userAgent,
            ipAddress: 'unknown' // 客户端无法获取真实IP
          };
          
          // 创建JSONP回调函数
          const callbackName = 'quizCallback_' + Date.now();
          window[callbackName] = function(response) {
            console.log('📡 Google Apps Script响应:', response);
            
            // 清理全局回调函数
            delete window[callbackName];
            
            if (response && response.success) {
              console.log('✅ Google Sheets数据保存成功');
              if (response.duplicate) {
                console.log('ℹ️ 邮箱已存在，但仍然算作成功');
              }
              resolve(true);
            } else {
              console.error('❌ Google Sheets返回错误:', response?.error || 'Unknown error');
              resolve(false);
            }
          };
          
          // 构建请求URL
          const params = new URLSearchParams({
            callback: callbackName,
            ...quizData
          });
          
          const requestUrl = `${GOOGLE_SCRIPT_URL}?${params.toString()}`;
          console.log('📤 请求URL长度:', requestUrl.length);
          
          // 使用script标签进行JSONP请求
          const script = document.createElement('script');
          script.src = requestUrl;
          script.onerror = function() {
            console.error('❌ Google Apps Script请求失败');
            delete window[callbackName];
            resolve(false);
          };
          
          // 设置超时
          const timeout = setTimeout(() => {
            console.warn('⏰ Google Apps Script请求超时');
            if (script.parentNode) {
              script.parentNode.removeChild(script);
            }
            delete window[callbackName];
            resolve(false);
          }, 10000);
          
          script.onload = function() {
            clearTimeout(timeout);
            if (script.parentNode) {
              script.parentNode.removeChild(script);
            }
          };
          
          document.head.appendChild(script);
          
        } catch (error) {
          console.error('❌ Google Apps Script提交异常:', error);
          resolve(false);
        }
      });
    }

    /**
     * 备用方法1: 尝试使用Shopify Ajax Customer API (已弃用，因CAPTCHA问题)
     */
    async tryAjaxCustomerAPI(email) {
      try {
        console.log('🌐 尝试Shopify Ajax API');
        
        // 尝试使用Ajax接口，通常不需要CAPTCHA
        const response = await fetch('/apps/customers/register', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            email: email,
            tags: ['quiz-subscriber', 'newsletter'],
            note: `Quiz Result: ${JSON.stringify({
              quizTitle: this.currentQuizData.quizTitle,
              result: this.currentQuizData.resultText,
              timestamp: new Date().toISOString()
            })}`
          })
        });
        
        console.log('📡 Ajax API响应状态:', response.status);
        return response.ok;
        
      } catch (error) {
        console.warn('Ajax API提交失败:', error);
        return false;
      }
    }
    
    /**
     * 方法2: 尝试绕过CAPTCHA的表单提交
     */
    async tryFormSubmissionWithoutCaptcha(email) {
      try {
        console.log('🔧 尝试绕过CAPTCHA');
        
        // 寻找页面上现有的newsletter表单
        const existingForm = document.querySelector('form[action*="contact"], form[action*="customer"]');
        
        if (existingForm) {
          console.log('📋 找到现有表单，尝试绕过CAPTCHA');
          
          // 创建URLSearchParams而不是FormData
          const params = new URLSearchParams();
          
          // 从现有表单获取必要字段
          const hiddenInputs = existingForm.querySelectorAll('input[type="hidden"]');
          hiddenInputs.forEach(input => {
            // 跳过CAPTCHA相关字段
            if (!input.name.includes('captcha') && !input.name.includes('g-recaptcha')) {
              params.append(input.name, input.value);
            }
          });
          
          // 添加我们的数据
          params.append('contact[email]', email);
          params.append('contact[tags]', 'quiz-subscriber,newsletter');
          params.append('form_type', 'customer');
          params.append('utf8', '✓');
          
          // 添加quiz数据
          const quizInfo = {
            quizTitle: this.currentQuizData.quizTitle,
            result: this.currentQuizData.resultText,
            timestamp: new Date().toISOString()
          };
          params.append('contact[note]', `Quiz Result: ${JSON.stringify(quizInfo)}`);
          
          const response = await fetch('/contact#newsletter-form', {
            method: 'POST',
            body: params,
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'X-Requested-With': 'XMLHttpRequest',
            }
          });
          
          console.log('📡 绕过CAPTCHA响应状态:', response.status);
          return response.ok || response.redirected;
        }
        
        return false;
      } catch (error) {
        console.warn('绕过CAPTCHA失败:', error);
        return false;
      }
    }

    /**
     * 方法3: 创建隐形iframe提交（绕过CAPTCHA检查）
     */
    async submitViaIframe(email) {
      return new Promise((resolve) => {
        console.log('🖼️ 创建隐形iframe');
        
        // 创建隐形iframe
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.style.visibility = 'hidden';
        iframe.style.position = 'absolute';
        iframe.style.left = '-9999px';
        iframe.name = 'quiz-submit-frame';
        
        document.body.appendChild(iframe);
        
        // 创建表单
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = '/contact';
        form.target = iframe.name;
        form.style.display = 'none';
        
        // 添加字段，避免CAPTCHA相关字段
        const fields = {
          'contact[email]': email,
          'contact[tags]': 'quiz-subscriber,newsletter',
          'form_type': 'customer',
          'utf8': '✓'
        };
        
        // 尝试获取token，但如果没有也继续
        const token = this.getCSRFToken();
        if (token) {
          fields['authenticity_token'] = token;
        }
        
        // 添加quiz数据
        const quizInfo = {
          quizTitle: this.currentQuizData.quizTitle,
          result: this.currentQuizData.resultText,
          timestamp: new Date().toISOString()
        };
        fields['contact[note]'] = `Quiz Result: ${JSON.stringify(quizInfo)}`;
        
        // 创建input字段
        Object.entries(fields).forEach(([name, value]) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = value;
          form.appendChild(input);
        });
        
        // 设置超时
        const timeout = setTimeout(() => {
          document.body.removeChild(iframe);
          document.body.removeChild(form);
          console.log('⏰ iframe提交超时，假设成功');
          resolve(true);
        }, 8000);
        
        // 监听iframe加载
        iframe.onload = function() {
          clearTimeout(timeout);
          
          try {
            // 检查iframe内容是否表明成功
            const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
            const content = iframeDoc.body ? iframeDoc.body.innerHTML.toLowerCase() : '';
            
            if (content.includes('thank') || content.includes('success') || content.includes('subscribed')) {
              console.log('✅ iframe检测到成功页面');
              resolve(true);
            } else {
              console.log('⚠️ iframe未检测到明确成功信号，假设成功');
              resolve(true);
            }
          } catch (e) {
            // 跨域限制，假设成功
            console.log('🔒 iframe跨域限制，假设成功');
            resolve(true);
          } finally {
            document.body.removeChild(iframe);
            document.body.removeChild(form);
          }
        };
        
        // 错误处理
        iframe.onerror = function() {
          clearTimeout(timeout);
          console.log('❌ iframe加载出错');
          document.body.removeChild(iframe);
          document.body.removeChild(form);
          resolve(false);
        };
        
        // 提交表单
        document.body.appendChild(form);
        console.log('📤 通过iframe提交表单');
        form.submit();
      });
    }

    /**
     * 方法4: 紧急备选方案 - 外部服务收集
     */
    async submitViaExternalService(email) {
      try {
        console.log('🌐 使用外部服务收集邮箱');
        
        // 使用 Formspree 或类似服务作为备选
        const quizData = {
          email: email,
          quizTitle: this.currentQuizData.quizTitle,
          result: this.currentQuizData.resultText,
          timestamp: new Date().toISOString(),
          referrer: window.location.href,
          userAgent: navigator.userAgent.substring(0, 100)
        };

        // 尝试发送到多个免费服务
        const services = [
          // Netlify Forms (如果站点托管在Netlify)
          { url: '/', method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, 
            body: new URLSearchParams({ ...quizData, 'form-name': 'quiz-email-collection' }) },
          
          // Google Forms 替代方案
          { url: 'https://httpbin.org/post', method: 'POST', 
            headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(quizData) }
        ];

        for (const service of services) {
          try {
            const response = await fetch(service.url, {
              method: service.method,
              headers: service.headers,
              body: service.body
            });

            console.log('🎯 外部服务响应:', response.status);
            if (response.ok) {
              console.log('✅ 外部服务提交成功');
              
              // 同时将数据保存到localStorage作为备份
              this.saveEmailToLocalStorage(email, quizData);
              return true;
            }
          } catch (serviceError) {
            console.warn('外部服务失败:', serviceError);
          }
        }

        // 如果所有外部服务都失败，至少保存到localStorage
        console.log('💾 保存到本地存储作为备份');
        this.saveEmailToLocalStorage(email, quizData);
        return true; // 返回true以便用户看到成功消息

      } catch (error) {
        console.error('外部服务提交完全失败:', error);
        return false;
      }
    }

    /**
     * 将邮箱数据保存到localStorage
     */
    saveEmailToLocalStorage(email, quizData) {
      try {
        const key = 'quiz-email-submissions';
        const existing = JSON.parse(localStorage.getItem(key) || '[]');
        existing.push({
          ...quizData,
          submissionTime: new Date().toISOString(),
          id: Date.now().toString()
        });

        // 只保留最近100条记录
        if (existing.length > 100) {
          existing.splice(0, existing.length - 100);
        }

        localStorage.setItem(key, JSON.stringify(existing));
        console.log('💾 邮箱数据已保存到本地存储');
      } catch (error) {
        console.warn('本地存储保存失败:', error);
      }
    }

    /**
     * 备用方法: 传统表单提交（已弃用，因为CAPTCHA问题）
     */
    async submitViaHiddenPage(email) {
      return new Promise((resolve) => {
        console.log('🔧 创建动态表单');
        
        // 创建隐藏的表单
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = '/contact';
        form.style.display = 'none';
        form.acceptCharset = 'UTF-8';
        
        // 添加必要字段
        const fields = {
          'utf8': '✓',
          'contact[email]': email,
          'contact[tags]': 'quiz-subscriber,newsletter',
          'form_type': 'customer'
        };
        
        // 获取CSRF token
        const token = this.getCSRFToken();
        if (token) {
          fields['authenticity_token'] = token;
        }
        
        // 添加quiz数据
        const quizInfo = {
          quizTitle: this.currentQuizData.quizTitle,
          result: this.currentQuizData.resultText,
          timestamp: new Date().toISOString()
        };
        fields['contact[note]'] = `Quiz Result: ${JSON.stringify(quizInfo)}`;
        
        // 创建input字段
        Object.entries(fields).forEach(([name, value]) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = value;
          form.appendChild(input);
        });
        
        // 添加提交完成监听
        let submitted = false;
        const timeout = setTimeout(() => {
          if (!submitted) {
            document.body.removeChild(form);
            console.log('⏰ 表单提交超时，假设成功');
            resolve(true);
          }
        }, 5000);
        
        // 监听页面跳转（Shopify通常会跳转）
        const originalUrl = window.location.href;
        const checkRedirect = setInterval(() => {
          if (window.location.href !== originalUrl) {
            submitted = true;
            clearTimeout(timeout);
            clearInterval(checkRedirect);
            console.log('🔄 检测到页面跳转，提交成功');
            
            // 跳转回原页面
            window.history.back();
            resolve(true);
          }
        }, 100);
        
        // 提交表单
        document.body.appendChild(form);
        
        console.log('📤 提交表单到:', form.action);
        console.log('📋 表单数据:', Object.entries(fields));
        
        try {
          form.submit();
        } catch (error) {
          submitted = true;
          clearTimeout(timeout);
          clearInterval(checkRedirect);
          document.body.removeChild(form);
          console.error('❌ 表单提交出错:', error);
          resolve(false);
        }
      });
    }

    /**
     * 获取页面的CSRF token
     */
    getCSRFToken() {
      // 尝试从meta tag获取
      const metaToken = document.querySelector('meta[name="csrf-token"]');
      if (metaToken) {
        return metaToken.getAttribute('content');
      }

      // 尝试从现有表单获取
      const formToken = document.querySelector('input[name="authenticity_token"]');
      if (formToken) {
        return formToken.value;
      }

      // 尝试从Rails全局变量获取
      if (window.Rails && window.Rails.csrfToken) {
        return window.Rails.csrfToken();
      }

      return null;
    }


    /**
     * 显示成功状态
     */
    showSuccessState() {
      const form = this.overlayElement.querySelector('.quiz-email-form');
      const successState = this.overlayElement.querySelector('.quiz-success-state');
      const resultPreview = this.overlayElement.querySelector('.quiz-result-preview');
      
      if (form) form.style.display = 'none';
      if (resultPreview) resultPreview.style.display = 'none';
      if (successState) successState.classList.add('show');
    }

    /**
     * 显示测试结果（在页面中）
     */
    showResult() {
      if (this.currentQuizData.onResultShown) {
        this.currentQuizData.onResultShown(this.currentQuizData);
      }

      this.dispatchEvent(QUIZ_EVENTS.resultShown, {
        quizData: this.currentQuizData
      });
    }

    /**
     * 关闭模态窗口
     */
    closeModal() {
      if (!this.overlayElement) return;

      this.overlayElement.classList.remove('active');
      
      setTimeout(() => {
        if (this.overlayElement && this.overlayElement.parentNode) {
          this.overlayElement.parentNode.removeChild(this.overlayElement);
        }
        this.overlayElement = null;
        this.modalElement = null;
        
        // 移除事件监听器
        document.removeEventListener('keydown', this.handleEscapeKey);
        
        // 触发关闭回调
        if (this.currentQuizData && this.currentQuizData.onModalClosed) {
          this.currentQuizData.onModalClosed(this.currentQuizData);
        }

        this.dispatchEvent(QUIZ_EVENTS.modalClosed, {
          quizData: this.currentQuizData
        });
      }, 300);
    }

    /**
     * 处理模态窗口关闭
     */
    handleModalClose() {
      this.closeModal();
    }

    /**
     * 处理ESC键
     */
    handleEscapeKey(e) {
      if (e.key === 'Escape' && this.overlayElement) {
        this.handleModalClose();
      }
    }

    /**
     * 显示字段错误
     */
    showFieldError(input, errorDiv, message) {
      input.classList.add('error');
      errorDiv.textContent = message;
      errorDiv.classList.add('show');
      input.focus();
    }

    /**
     * 验证邮箱格式
     */
    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    }

    /**
     * HTML转义
     */
    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    /**
     * 触发自定义事件
     */
    dispatchEvent(eventName, detail) {
      const event = new CustomEvent(eventName, { detail });
      document.dispatchEvent(event);
    }

    /**
     * 公开的工具方法：验证邮箱
     */
    validateEmail(email) {
      return this.isValidEmail(email);
    }

    /**
     * 公开的工具方法：直接显示邮箱收集表单
     */
    showEmailForm(resultData, options = {}) {
      const config = {
        quizResult: resultData,
        ...options
      };
      this.submitQuizResult(config);
    }
  }

  // 创建全局实例
  window.QuizEmailHandler = new QuizEmailHandler();

  // 向后兼容的静态方法
  window.QuizEmailHandler.submitResult = function(email, quizResult, quizTitle) {
    console.warn('QuizEmailHandler.submitResult is deprecated. Use QuizEmailHandler.submitQuizResult instead.');
    return window.QuizEmailHandler.submitQuizResult({
      quizResult: quizResult,
      quizTitle: quizTitle || 'Quiz Result'
    });
  };

  // 暴露事件常量
  window.QuizEmailHandler.EVENTS = QUIZ_EVENTS;

  // 添加调试方法
  window.QuizEmailHandler.debug = {
    checkCSRFToken: function() {
      const token = window.QuizEmailHandler.getCSRFToken();
      console.log('🔑 CSRF Token:', token ? 'Found' : 'Not found', token);
      return token;
    },
    
    checkExistingForms: function() {
      const forms = document.querySelectorAll('form');
      console.log('📋 页面上的所有表单:');
      forms.forEach((form, index) => {
        console.log(`表单 ${index + 1}:`, {
          action: form.action,
          method: form.method,
          id: form.id,
          class: form.className,
          hiddenFields: [...form.querySelectorAll('input[type="hidden"]')].map(input => ({
            name: input.name,
            value: input.value
          }))
        });
      });
      
      const newsletterForms = document.querySelectorAll('form[action*="contact"], form[action*="customer"]');
      console.log('📧 Newsletter相关表单数量:', newsletterForms.length);
      
      return { allForms: forms.length, newsletterForms: newsletterForms.length };
    },
    
    testDirectSubmission: async function(testEmail = 'debug-test@example.com') {
      console.log('🧪 测试Google Sheets提交方法...');
      
      const handler = window.QuizEmailHandler;
      handler.currentQuizData = {
        quizTitle: 'Debug Test Quiz',
        resultText: 'Debug Test Result',
        timestamp: new Date().toISOString(),
        quizResult: {
          character: 'test-character',
          characterName: 'Test Character',
          answers: { test: 'answer' },
          detailedAnswers: [{ question: 'Test?', answer: 'Test Answer' }]
        }
      };
      
      const result = await handler.submitToGoogleSheets(testEmail);
      console.log('🎯 Google Sheets提交结果:', result);
      return result;
    },

    testGoogleSheetsOnly: async function(testEmail = 'sheets-test@example.com') {
      console.log('📊 专门测试Google Apps Script...');
      
      const handler = window.QuizEmailHandler;
      handler.currentQuizData = {
        quizTitle: 'Google Sheets Test',
        resultText: 'Testing Google Sheets Integration',
        quizResult: {
          character: 'barbie1',
          characterName: 'Fashionista Barbie',
          timestamp: new Date().toISOString()
        }
      };
      
      const result = await handler.submitToGoogleAppsScript(testEmail);
      console.log('📈 Google Apps Script结果:', result);
      return result;
    },

    testCaptchaBypass: async function(testEmail = 'captcha-test@example.com') {
      console.log('🚫 测试绕过CAPTCHA方法...');
      
      // 测试直接POST到不同的端点
      const alternatives = [
        '/contact#newsletter',
        '/pages/newsletter',
        '/a/newsletter/subscribe',
        '/tools/recurring-payments/newsletter'
      ];

      for (const endpoint of alternatives) {
        try {
          console.log('🔍 尝试端点:', endpoint);
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: new URLSearchParams({
              'contact[email]': testEmail,
              'contact[tags]': 'quiz-test',
              'form_type': 'customer'
            })
          });
          
          console.log(`📡 ${endpoint} 响应:`, response.status);
          if (response.ok) {
            console.log('✅ 找到可用端点:', endpoint);
            return endpoint;
          }
        } catch (error) {
          console.log(`❌ ${endpoint} 失败:`, error.message);
        }
      }
      
      return null;
    },

    checkLocalStorage: function() {
      const key = 'quiz-email-submissions';
      const data = localStorage.getItem(key);
      
      if (data) {
        const submissions = JSON.parse(data);
        console.log('💾 本地存储的邮箱提交记录:', submissions.length, '条');
        submissions.forEach((submission, index) => {
          console.log(`  ${index + 1}. ${submission.email} - ${submission.quizTitle} (${submission.submissionTime})`);
        });
        return submissions;
      } else {
        console.log('💾 本地存储无邮箱记录');
        return [];
      }
    },
    
    testEmailSubmission: function(testEmail = 'test@example.com') {
      console.log('🚀 测试完整邮箱收集流程...');
      return window.QuizEmailHandler.submitQuizResult({
        quizResult: { test: true, timestamp: new Date().toISOString() },
        quizTitle: 'Debug Test',
        resultText: 'Test Result',
        onEmailSubmitted: function(email) {
          console.log('✅ Debug: 邮箱提交成功回调:', email);
        }
      });
    },

    checkShopifyEndpoint: async function() {
      try {
        const response = await fetch('/contact', {
          method: 'GET',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        console.log('🌐 Contact endpoint status:', response.status);
        console.log('📡 Response headers:', [...response.headers.entries()]);
        return response.status;
      } catch (error) {
        console.error('❌ Endpoint check failed:', error);
        return null;
      }
    },

    fullDiagnostic: function() {
      console.log('🔍 === Quiz Email Handler 完整诊断 ===');
      console.log('📊 Google Sheets邮箱收集系统已就绪');
      console.log('🌐 Google Apps Script URL: 已配置');
      console.log('📋 Google Sheets ID: 15rgkrCaNbBTuHvMCJ0ukoHsvMOMO6DA7lEbn73UERNQ');
      console.log('');
      
      this.checkLocalStorage();
      console.log('');
      console.log('📋 测试命令:');
      console.log('  QuizEmailHandler.debug.testGoogleSheetsOnly() - 测试Google Sheets连接');
      console.log('  QuizEmailHandler.debug.testDirectSubmission() - 测试完整流程');
      console.log('  QuizEmailHandler.debug.checkLocalStorage() - 检查本地备份');
      console.log('');
      console.log('✅ 系统已完全配置，可以直接使用！');
      console.log('===============================');
    }
  };

  console.log('QuizEmailHandler loaded successfully');
  console.log('Debug methods available: QuizEmailHandler.debug');

})();